import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import companyLogo from "../assets/images/nnfitwatermark.png";

export const exportBusinessReport = (members, payments, report, gym) => {
  const doc = new jsPDF("p", "mm", "a4");

  const pageWidth = doc.internal.pageSize.getWidth();
  // const pageHeight = doc.internal.pageSize.getHeight();

  //------------------------------------------
  // Cover Page
  //------------------------------------------

  doc.addImage(companyLogo, "PNG", 75, 18, 60, 60);

  doc.setFontSize(26);
  doc.setTextColor(230, 120, 20);

  doc.text("BUSINESS REPORT", pageWidth / 2, 95, {
    align: "center",
  });

  doc.setFontSize(17);
  doc.setTextColor(0);

  doc.text(gym?.gymName || "Gym Report", pageWidth / 2, 110, {
    align: "center",
  });

  doc.setFontSize(12);

  doc.text(`Owner : ${gym?.ownerName || "-"}`, pageWidth / 2, 120, {
    align: "center",
  });

  doc.text(`Generated : ${new Date().toLocaleString()}`, pageWidth / 2, 128, {
    align: "center",
  });

  doc.setDrawColor(230, 120, 20);

  doc.line(20, 145, 190, 145);

  doc.setFontSize(18);

  doc.text("Powered By", pageWidth / 2, 165, { align: "center" });

  doc.setFontSize(22);

  doc.setTextColor(230, 120, 20);

  doc.text("NN FIT", pageWidth / 2, 178, { align: "center" });

  doc.setFontSize(12);

  doc.setTextColor(80);

  doc.text("Where AI Meets Innovation", pageWidth / 2, 187, {
    align: "center",
  });

  //------------------------------------------
  // Page 2
  //------------------------------------------

  doc.addPage();
  doc.setFontSize(22);

  doc.setTextColor(230, 120, 20);

  doc.text("Gym Information", 15, 20);

  autoTable(doc, {
    startY: 30,

    head: [["Field", "Details"]],

    body: [
      ["Gym Name", gym?.gymName || "-"],
      ["Owner Name", gym?.ownerName || "-"],
      ["Email", gym?.email || "-"],
      ["Phone", gym?.phone || "-"],
      ["Registration", gym?.registrationType || "-"],
      ["Subscription", gym?.subscriptionPlan || "-"],
      ["Subscription Status", gym?.subscriptionStatus || "-"],
      ["Payment Status", gym?.paymentStatus || "-"],
      ["Members", report.totalMembers],
      ["Active Members", report.activeMembers],
      ["Expired Members", report.expiredMembers],
      ["Trainers", report.totalTrainers],
    ],

    theme: "grid",

    headStyles: {
      fillColor: [230, 120, 20],
    },

    styles: {
      fontSize: 11,
    },
  });
  doc.addPage();

  doc.setFontSize(22);

  doc.setTextColor(230, 120, 20);

  doc.text("Business Summary", 15, 20);

  const cards = [
    ["Total Members", report.totalMembers],
    ["Active Members", report.activeMembers],
    ["Expired Members", report.expiredMembers],
    ["Total Trainers", report.totalTrainers],
    ["Revenue", `Rs. ${report.totalRevenue}`],
    ["Pending", `Rs. ${report.pendingPayments}`],
  ];

  let x = 15;
  let y = 35;

  cards.forEach((card, index) => {
    doc.setFillColor(245, 245, 245);

    doc.roundedRect(x, y, 80, 32, 3, 3, "F");

    doc.setFontSize(11);
    doc.setTextColor(120);

    doc.text(card[0], x + 5, y + 10);

    doc.setFontSize(18);
    doc.setTextColor(0);

    doc.text(String(card[1]), x + 5, y + 23);

    x += 90;

    if ((index + 1) % 2 === 0) {
      x = 15;
      y += 42;
    }
  });

  // Business Summary Cards
  cards.forEach((card, index) => {
    doc.setFillColor(245, 245, 245);

    doc.roundedRect(x, y, 80, 32, 3, 3, "F");

    doc.setFontSize(11);
    doc.setTextColor(120);

    doc.text(card[0], x + 5, y + 10);

    doc.setFontSize(18);
    doc.setTextColor(0);

    doc.text(String(card[1]), x + 5, y + 23);

    x += 90;

    if ((index + 1) % 2 === 0) {
      x = 15;
      y += 42;
    }
  });

  // ===== ADD THIS HERE =====

  const totalPages = doc.internal.getNumberOfPages();

  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);

    doc.setDrawColor(220);
    doc.line(15, 287, 195, 287);

    doc.setFontSize(10);
    doc.setTextColor(120);

    doc.text("Powered By NN FIT", 15, 293);

    doc.text(`Page ${i} of ${totalPages}`, 170, 293);
  }

  // ===== SAVE PDF =====

  doc.save(`${gym?.gymName || "Business"}-Business-Report.pdf`);
};
